import { https } from "../http";
import store from "../store";

import {
  setAddBillingLoading,
  setAllBilling,
  setBillingCache,
  setBillingCard,
  setBillingLookup,
  setElgibilityStatus,
  //   setReports,
  setLoading,
  setPaymentBilling,
} from "../store/reducers/billing";
import { showError } from "../utils/index";

// POST
const createBilling = async (data, callback) => {
  try {
    store.dispatch(setAddBillingLoading(true));
    let response = await https().post("billing/create", data);
    console.log('response in the action',response);


    if (response?.status === 200) {
      // getReports(false);
      callback?.();
    }

    return response
  } catch (error) {
    store.dispatch(setAddBillingLoading(false));
    await showError(error?.response?.data?.message, error?.response?.status);
    return { awaitedError: true };
  }
};

//get

const getAllBillingModal = async (payload, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));

    const page = payload?.page || 1;
    const params = new URLSearchParams();
    if (payload?.name) params.append('name', payload.name);
    if (payload?.dateRange) params.append('dateRange', payload.dateRange);
    if (payload?.status && payload.status !== 'all') params.append('status', payload.status);
    const query = params.toString() ? `?${params.toString()}` : '';

    let response = await https().get(`billing/${page}${query}`);
    

    
    if (response?.status === 200) {
      store.dispatch(setAllBilling(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// get eligibility status

const getelibilitystatus = async (data, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().post("billing/get-eligibility", data);

    console.log("response  eligibity", response);

    if (response?.status === 200) {
      store.dispatch(setElgibilityStatus(response?.data?.eligibility));
    }

    return response;
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};



// get billling payment 

// /billingpayment/:page


// const getAllBillingPayments = async (payload, showLoading = true) => {
//   try {
//     if (showLoading) store.dispatch(setLoading(true));

//     let response = await https().get(
//       `billing/billingpayment/${payload && payload.page ? `${payload.page}` : 'all'}
//       ${
//         payload && payload.name ? `?search=${payload.name}` : ''
//       }`
//     );




//     if (response?.status === 200) {
//       store.dispatch(setPaymentBilling(response?.data));
//     }
//   } catch (error) {
//     store.dispatch(setLoading(false));
//     showError(error?.response?.data?.message, error?.response?.status);
//     return false;
//   }
// };

const getAllBillingPayments = async (payload, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));

    const page = payload && payload.page ? `${payload.page}` : 'all';

    let query = '';
    if (payload?.name) {
      query += `?search=${payload.name}`;
    }
    if (payload?.dateRange) {
      query += `${query ? '&' : '?'}dateRange=${payload.dateRange}`;
    }

    let response = await https().get(`billing/billingpayment/${page}${query}`);

    if (response?.status === 200) {
      store.dispatch(setPaymentBilling(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


const editBilling = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddBillingLoading(true));
    let response = await https().put(
      `/billing/${data?.id}/${data?.claimid}/${data?.claimmongoid}`,
      data
    );

    if (response?.status === 200) {
      await getAllBillingModal(showLoading);
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const removeBilling = async (data, showLoading = true) => {
  try {
    store.dispatch(setAddBillingLoading(true));

    // console.log('data',data);

    let response = await https().delete(
      `/billing/${data?.id}/${data?.claimid}`
    );

    if (response?.status === 200) {
      await getAllBillingModal((showLoading = true));
    }

    return response;
  } catch (error) {
    store.dispatch(setAddBillingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};


const BillingConnectCard = async (data, callback) => {
  try {
    store.dispatch(setAddBillingLoading(true));
    let response = await https().post("billing/billingcardconnect", data);
    console.log('response in the action',response);
    

    if (response?.status === 200) {
      // getReports(false);
      callback?.();
    }

    return response
  } catch (error) {
    store.dispatch(setAddBillingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


const getBillingCard = async (data, callback) => {
  try {
    store.dispatch(setAddBillingLoading(true));
    let response = await https().get("billing/card/cardbilling");
    console.log('response in the action',response);
    

    if (response?.status === 200) {
      store.dispatch(setBillingCard(response?.data));
    }


  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// get billing lookups


const BillingLookups = async (data, callback) => {
  try {
    store.dispatch(setAddBillingLoading(true));
    let response = await https().post("billing/look-up-details", data);
    console.log('response in the action',response);

    
    

    if (response?.status === 200) {
      store.dispatch(setBillingLookup(response?.data));
    }

    return response
  } catch (error) {
    store.dispatch(setAddBillingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// pay billing fees directly


const PayBillingAmount=async(data,showLoading = true)=>{
  try {
    store.dispatch(setAddBillingLoading(true));
    let response = await https().post("billing/pay-transaction-fee", data);
    console.log('response in the action',response);
    

    if (response?.status === 200) {
      // getReports(false);
      getAllBillingPayments()
     
    }

    return response
  } catch (error) {
    store.dispatch(setAddBillingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
}

// get era details

const GetBillingERADetais = async (data, callback) => {
  try {
    store.dispatch(setAddBillingLoading(true));
    let response = await https().post("billing/get-era-details", data);
    console.log('response in the action',response);
    return response
  } catch (error) {
    store.dispatch(setAddBillingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


const AddBillingCache=async(data)=>{

    try {

    let response = await https().post("billing/save-billing-cache", data);
    console.log('response in the action',response);
    



    return response
  } catch (error) {

    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
}




const getBillingCache=async(data)=>{

    try {
  store.dispatch(setAddBillingLoading(true));
    let response = await https().get("billing/cache/billing", data);
    console.log('response in the action',response);
    
    if (response?.status === 200) {
      store.dispatch(setBillingCache(response?.data));
    }


    return response
  } catch (error) {
    store.dispatch(setAddBillingLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
}


const deleteBillingCache = async (id) => {
  try {
    const response = await https().delete(`billing/cache/${id}`);
    if (response?.status === 200) {
      getBillingCache({ page: 1 });
    }
    return response;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

export {
  createBilling,
  getAllBillingModal,
  getelibilitystatus,
  editBilling,
  removeBilling,
  getAllBillingPayments,
  BillingConnectCard,
  getBillingCard,
  BillingLookups,
  PayBillingAmount,
  GetBillingERADetais,
  AddBillingCache,
  getBillingCache,
  deleteBillingCache,
};
